export default {
  baseStyle: {
    color: 'legacy-primary.500',
  },
}
